import clsx from 'clsx';
import * as React from 'react';
import {
    ColorSwatch as RACColorSwatch,
    type ColorSwatchProps as RACColorSwatchProps,
} from 'react-aria-components';

export type ColorSwatchProps = RACColorSwatchProps & {
    size?: number;
};

/**
 * A ColorSwatch displays a preview of a selected color.
 */
export const ColorSwatch = React.forwardRef(function ColorSwatch(
    props: ColorSwatchProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    const { size, ...rest } = props;
    return (
        <RACColorSwatch
            ref={ref}
            style={size ? { width: size, height: size, ...rest.style } : undefined}
            {...rest}
            className={clsx('rounded shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]', rest.className)}
        />
    );
});
